import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DateFunctions } from "common/datefunctions";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { CUSTOMER_APIs } from "apihandlers/customer";
import AutoComplete from "components/Custom/AutoComplete";
import { GEO_APIs } from "apihandlers/geography";

const DealerManagement = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [states, setStates] = useState([]);

  const stateRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getStates();
    }
  }, [loading]);

  const getStates = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getStates(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.stateName,
          };
        });
        setStates(list);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await CUSTOMER_APIs.getCustSalesTypes(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCities:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "fromDate",
      name: LABELS.FROM_DATE,
      width: "7%",
      type: "date",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "toDate",
      name: LABELS.TO_DATE,
      width: "7%",
      type: "date",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "state",
      name: LABELS.STATE,
      width: "20%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },

    {
      key: "timelyReplacement",
      name: LABELS.TIMELY_REPLACEMENT_OF_DEALERS,
      width: "15%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "growthPer",
      name: LABELS.GROWTH_PER_OF_REPLACED_DEALER,
      width: "15%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "smoothDealer",
      name: LABELS.SMOOTH_DEALER_CLOSING_PROCESS_WEIGHTAGE,
      width: "18%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "dealerRoi",
      name: LABELS.DEALER_ROI,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  //   const onchange=()=>{
  //     const value=
  //   }

  const manageDealerManagement = () => {
    const fromDate = (document.getElementById("fromDate") as HTMLInputElement)
      .value;
    const toDate = (document.getElementById("toDate") as HTMLInputElement)
      .value;
    const state = stateRef.current.selectedValue.id;
    const timelyReplacement = (
      document.getElementById("timelyReplacement") as HTMLInputElement
    ).value;
    const growthPerReplaced = (
      document.getElementById("growthPer") as HTMLInputElement
    ).value;
    const smoothDealerClosing = (
      document.getElementById("smoothDealer") as HTMLInputElement
    ).value;
    const dealerRoi = (document.getElementById("dealerRoi") as HTMLInputElement)
      .value;

    // Validations
    let errors = [];
    if (fromDate === "") {
      errors.push({
        id: "fromDate",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDate === "") {
      errors.push({
        id: "toDate",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!state) {
      errors.push({
        id: "state",
        msg:
          "<span class='bold'>" +
          LABELS.STATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!timelyReplacement) {
      errors.push({
        id: "timelyReplacement",
        msg:
          "<span class='bold'>" +
          LABELS.TIMELY_REPLACEMENT_OF_DEALERS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!growthPerReplaced) {
      errors.push({
        id: "growthPerReplaced",
        msg:
          "<span class='bold'>" +
          LABELS.GROWTH_PER_OF_REPLACED_DEALER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!smoothDealerClosing) {
      errors.push({
        id: "smoothDealerClosing",
        msg:
          "<span class='bold'>" +
          LABELS.SMOOTH_DEALER_CLOSING_PROCESS_WEIGHTAGE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!dealerRoi) {
      errors.push({
        id: "dealerRoi",
        msg:
          "<span class='bold'>" +
          LABELS.DEALER_ROI +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (Number(growthPerReplaced) < 0 || Number(growthPerReplaced) > 100) {
      errors.push({
        id: "growthError",
        msg:
          "<span class='bold'>" +
          LABELS.GROWTH_PER_OF_REPLACED_DEALER +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }
    if (Number(smoothDealerClosing) < 0 || Number(smoothDealerClosing) > 100) {
      errors.push({
        id: "growthError",
        msg:
          "<span class='bold'>" +
          LABELS.SMOOTH_DEALER_CLOSING_PROCESS_WEIGHTAGE +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }
    if (Number(dealerRoi) < 0 || Number(dealerRoi) > 100) {
      errors.push({
        id: "growthError",
        msg:
          "<span class='bold'>" +
          LABELS.DEALER_ROI +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      fromDate,
      toDate,
      state,
      timelyReplacement,
      growthPerReplaced,
      smoothDealerClosing,
      dealerRoi,

      //activeStatus,
    };
    console.log("args", args);

    setIsSubmit(true);

    setSelectedRow({});
    setManageDialog(false);
    reloadGrid();

    //TODO API still in progress
    //     CUSTOMER_APIs.manageCustSalesType(args).then((res) => {
    //       setIsSubmit(false);
    //       if (res.status === 200) {
    //         COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //         setSelectedRow({});
    //         setManageDialog(false);
    //         reloadGrid();
    //       } else {
    //         COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //       }
    //     });
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.DEALER_MANAGEMENT}</li>
        </ul>
        <h4>{TITLES.DEALER_MANAGEMENT}</h4>
        <p>{SUB_TITLES.DEALER_MANAGEMENT}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.DEALER_MANAGEMENT}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " +
                LABELS.DEALER_MANAGEMENT +
                ": " +
                selectedRow.salesType
              : "Add New " + LABELS.DEALER_MANAGEMENT
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <label
            style={{
              fontWeight: "500",
              fontSize: 14,
              marginTop: 6,
              marginRight: 8,
            }}
          >
            {LABELS.FROM_DATE}
          </label>
          <TxtRow
            type={"date"}
            id="fromDate"
            defaultValue={DateFunctions.getDate("today", "from", "YYYY-MM-DD")}
          />
          <label
            style={{
              fontWeight: "500",
              fontSize: 14,
              marginTop: 6,
              marginRight: 8,
            }}
          >
            {LABELS.TO_DATE}
          </label>
          <TxtRow
            type={"date"}
            id="toDate"
            defaultValue={DateFunctions.getDate(
              "thismonth",
              "to",
              "YYYY-MM-DD"
            )}
          />
          <div className="formGroup  ">
            <label>{LABELS.STATE}</label>
            {/* {<span className="red">{" *"}</span>} */}
            <AutoComplete
              list={states}
              childRef={stateRef}
              defaultValue={
                selectedRow.dealerId
                  ? {
                      id: selectedRow.dealerId,
                      label: selectedRow.dealerName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              //   disabled={isSubmit}
            />
          </div>

          <div className="formGroup ">
            <TxtRow
              id={"timelyReplacement"}
              type={"text"}
              label={LABELS.TIMELY_REPLACEMENT_OF_DEALERS}
              // required={true}
              defaultValue={selectedRow.timelyReplacement}
              //   disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"growthPer"}
              type={"text"}
              label={LABELS.GROWTH_PER_OF_REPLACED_DEALER}
              // required={true}
              defaultValue={selectedRow.growthPer}
              //   disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"smoothDealer"}
              type={"text"}
              label={LABELS.SMOOTH_DEALER_CLOSING_PROCESS_WEIGHTAGE}
              //required={true}
              defaultValue={selectedRow.smoothDealer}
              //   disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"dealerRoi"}
              type={"text"}
              label={LABELS.DEALER_ROI}
              //required={true}
              defaultValue={selectedRow.dealerRoi}
              //   disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div>
            <Btn
              text={LABELS.SAVE}
              //   loading={isSubmit}
              onClick={manageDealerManagement}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(DealerManagement);
